import { createTheme } from "../theme";
export var smartrent = createTheme({
    name: "smartrent",
    customDerivedColors: function (mode) {
        var isLightMode = mode === "light";
        var brand100 = "#E7FFFD";
        var brand200 = "#AFF8F3";
        var brand300 = "#88E2E7";
        var brand400 = "#5BC6CC";
        var brand500 = "#00ACA0";
        var brand600 = "#00927C";
        var brand700 = "#037766";
        var brand800 = "#0D594E";
        var brand900 = "#112D28";
        return {
            primary: isLightMode ? brand700 : brand500,
            secondary: isLightMode ? brand800 : brand600,
            tertiary: isLightMode ? brand600 : brand400,
            brand100: brand100,
            brand200: brand200,
            brand300: brand300,
            brand400: brand400,
            brand500: brand500,
            brand600: brand600,
            brand700: brand700,
            brand800: brand800,
            brand900: brand900,
        };
    },
});
//# sourceMappingURL=smartrent.js.map